<ui-view name="nav"></ui-view>
<div id="content" class="content" role="main" aria-labelledby="main-lm-title">
    <ui-view name="content"></ui-view>
</div>
